const ENCODED_FILENAME = /filename\*=\s*([^']*)'[^']*'([^;]+)/i;
const QUOTED_FILENAME = /filename\s*=\s*"((?:[^"\\]|\\.)*)"/i;
const BARE_FILENAME = /filename\s*=\s*([^;]+)/i;

/** Drop any path so a server-sent name cannot point outside the download folder. */
const baseName = (value: string): string => {
  const segments = value.split(/[\\/]/);
  return segments[segments.length - 1].trim();
};

const decode = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/** Pull the filename the server chose out of a Content-Disposition header. */
export const filenameFromContentDisposition = (
  header?: string | null,
): string | null => {
  if (!header) return null;

  const encoded = header.match(ENCODED_FILENAME);
  const quoted = header.match(QUOTED_FILENAME);
  const bare = quoted ? null : header.match(BARE_FILENAME);

  const raw = encoded
    ? decode(encoded[2])
    : quoted
      ? quoted[1].replace(/\\(.)/g, "$1")
      : bare?.[1];

  if (!raw) return null;

  const name = baseName(raw);
  return name.length > 0 ? name : null;
};
